import { Component, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnChanges {
  @Output() search = new EventEmitter<string>();
  @Input() isMenuView = false;
  @Input() placeholder = 'Buscar';
  @Input() clearTrigger = false;

  @ViewChild(IonInput, { static: true }) input!: IonInput;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clearTrigger'] && this.clearTrigger) {
      this.clearInputValue();
    }
  }

  onInput(event: any) {
    const value = event.target.value;
    this.search.emit(value);
  }

  clearInputValue() {
    if (this.input) {
      this.input.value = '';
    }
  }
}
